import { TypedForm, ObjectSchema, object, date } from 'libs/form';
import { TFunc } from 'libs/i18n';
import { getToday } from 'modules/client/common/helpers';

export interface CompanyConstituentDocsDateFormType {
  constituentDocsDateOfLastChange?: Date;
}

export const getCompanyConstituentDocsDateSchema = (
  t: TFunc
): ObjectSchema<CompanyConstituentDocsDateFormType> =>
  object({
    constituentDocsDateOfLastChange: date()
      .required()
      .max(getToday(), t('validation.maxDate')),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<CompanyConstituentDocsDateFormType>();
